import {OperatorApplicationMenuSection} from "~/operatorApplication/vue/layout/Interface";
import {
    OPERATOR_APPLICATION_DIALOGS_ROUTE_LIST_ID_MAIN,
    OPERATOR_APPLICATION_DIALOGS_ROUTE_NAME,
    OPERATOR_APPLICATION_NEWS_ROUTE_NAME
} from "~/operatorApplication/ts/router/OperatorApplicationRouteNames";
import {
    OperatorApplicationEventManager,
    SELECT_OPERATOR_FOR_ANOTHER_OPERATORS_DIALOG
} from "~/operatorApplication/ts/OperatorApplicationEventManager";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import {ref, shallowRef} from "vue";


class OperatorApplicationRouting {
    sectionId = ref<string>();
    menu = shallowRef<OperatorApplicationMenuSection[]>([]);

    setSectionId(id: string) {
        this.sectionId.value = id;
    }

    getDialogsSectionId(buddyListId: string): string {
        return OPERATOR_APPLICATION_DIALOGS_ROUTE_NAME + "_" + buddyListId;
    }

    setMenu(menu: OperatorApplicationMenuSection[]) {
        this.menu.value = menu as any;
    }

    isBuddyListSelected(buddyListId: string): boolean {
        return this.getDialogsSectionId(buddyListId) === this.sectionId.value;
    }

    openMainDialogs() {
        this.openDialogsByBuddyListId(OPERATOR_APPLICATION_DIALOGS_ROUTE_LIST_ID_MAIN);
    }

    openNews() {
        this.setSectionId(OPERATOR_APPLICATION_NEWS_ROUTE_NAME);
    }

    openDialogsByBuddyListId(buddyListId: string) {
        this.setSectionId(this.getDialogsSectionId(buddyListId));
    }


    clear() {
        this.setMenu([]);
        this.setSectionId(null);
    }

}

export const OperatorApplicationRoutingStore = new OperatorApplicationRouting();

OperatorApplicationEventManager.addEventListener(
    SELECT_OPERATOR_FOR_ANOTHER_OPERATORS_DIALOG,
    () => {
        let buddyList = OperatorAccountStore.data.value.buddyListConfig.find(item => item.isAnotherOperatorBuddyList);
        if (buddyList) {
            let sectionId = OperatorApplicationRoutingStore.getDialogsSectionId(buddyList.id);
            OperatorApplicationRoutingStore.setSectionId(sectionId);
        }
    }
)
